var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgScribbleArrow = function SvgScribbleArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.11 2.994h.001l.014-.002a17.546 17.546 0 0 1 1.383-.055c.902 0 2.175.06 3.643.3 2.944.48 6.612 1.674 9.67 4.498 1.464 1.35 2.55 3.281 3.339 5.492.787 2.204 1.259 4.626 1.535 6.894.27 2.224.35 4.275.36 5.788l-4.245-4.83a1 1 0 1 0-1.502 1.32l5.94 6.761a1 1 0 0 0 1.412.091l6.76-5.94a1 1 0 1 0-1.32-1.503l-5.045 4.433v-.262a53.57 53.57 0 0 0-.375-6.1c-.287-2.357-.783-4.935-1.637-7.325-.85-2.383-2.078-4.64-3.865-6.289-3.44-3.176-7.523-4.483-10.704-5.002A24.842 24.842 0 0 0 2.508.938a19.54 19.54 0 0 0-1.492.056 7.207 7.207 0 0 0-.089.008l-.025.003H.89v.001L1 2l-.11-.994a1 1 0 0 0 .22 1.988",
    clipRule: "evenodd"
  })));
};

export default SvgScribbleArrow;